// useMagicHover.js
import { useRef, useEffect } from "react";
import { gsap } from "gsap";

export default function useMagicHover(options = {}) {
  const {
    enableTilt = true,
    glowColor = "132, 0, 255", // "R, G, B"
  } = options;

  const cardRef = useRef(null);

  useEffect(() => {
    const el = cardRef.current;
    if (!el) return;

    const handleMouseMove = (e) => {
      if (!el) return;
      const rect = el.getBoundingClientRect();
      if (!rect || rect.width === 0 || rect.height === 0) return;
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;

      const rotateX = enableTilt ? ((y - centerY) / centerY) * -10 : 0;
      const rotateY = enableTilt ? ((x - centerX) / centerX) * 10 : 0;

      const spotlight = `radial-gradient(circle at ${x}px ${y}px, rgba(${glowColor}, 0.4), transparent 55%)`;

      // 🔹 Mucho más rápido y responsivo
      gsap.to(el, {
        rotateX,
        rotateY,
        scale: 1.02,
        boxShadow: `0 18px 40px rgba(${glowColor}, 0.35)`,
        backgroundImage: spotlight,
        borderColor: `rgba(${glowColor}, 0.8)`,
        transformPerspective: 1000,
        transformOrigin: "center center",
        duration: 0.12,
        ease: "power1.out",
      });
    };

    const handleMouseEnter = () => {
      if (!el) return;
      gsap.to(el, {
        scale: 1.02,
        duration: 0.1,
        ease: "power1.out",
      });
    };

    const handleMouseLeave = () => {
      if (!el) return;
      gsap.to(el, {
        rotateX: 0,
        rotateY: 0,
        scale: 1,
        boxShadow: "none",
        backgroundImage: "none",
        borderColor: "rgba(255,255,255,0.08)",
        duration: 0.14,
        ease: "power1.out",
      });
    };

    el.addEventListener("mousemove", handleMouseMove);
    el.addEventListener("mouseenter", handleMouseEnter);
    el.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      if (!el) return;
      el.removeEventListener("mousemove", handleMouseMove);
      el.removeEventListener("mouseenter", handleMouseEnter);
      el.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, [enableTilt, glowColor]);

  return cardRef;
}
